import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "/mnt/f/Users/sGerli/Development/rebble/rebble-store/build/sprite_module.conf.js";
var symbol = new SpriteSymbol({
  "id": "iconHeart",
  "use": "iconHeart-usage",
  "viewBox": "0 0 23 25",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 23 25\" id=\"iconHeart\">\r\n  <polygon fill=\"#FFFFFF\" fill-rule=\"evenodd\" stroke=\"#000000\" stroke-width=\"2\" points=\"0 5 5 0 10.5 5 16 0 21 5 21 10.5 10.5 20.996 0 10.5\" transform=\"translate(1 2)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/Heart.svg
// module id = ANsz
// module chunks = 1